// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2-sxH","col":"styles_col__329i7"};